import { Button, Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import { NoResults } from "lib/@components/no-results/no-results"

export function AuthoringRecommendationsEmptyState({ sourceFilter, isRefreshingStyleGuide, onRefreshStyleGuide }) {
    return (
        <Stack
            spacing={1}
            alignItems="center"
            justifyContent="center"
            sx={{ height: "100%", px: 2, textAlign: "center" }}
        >
            <NoResults mt={0} width={220} childrenStyle={{ maxWidth: 320 }}>
                {resolveEmptyStateMessage(sourceFilter)}
            </NoResults>
            <If value={sourceFilter === "styleGuide"}>
                <Button size="small" onClick={onRefreshStyleGuide} disabled={isRefreshingStyleGuide}>
                    {resolveRefreshStyleGuideLabel(isRefreshingStyleGuide)}
                </Button>
            </If>
        </Stack>
    )
}

function resolveEmptyStateMessage(sourceFilter) {
    if (sourceFilter === "styleGuide") {
        return "No style-guide recommendations are available for this schedule yet."
    }

    return "No approved recommendations are available for this schedule."
}

function resolveRefreshStyleGuideLabel(isRefreshingStyleGuide) {
    if (isRefreshingStyleGuide) return "Checking style guide..."
    return "Check style guide"
}
